import { render, staticRenderFns } from "./Nutrition_facts.vue?vue&type=template&id=6000fe5f&scoped=true&"
import script from "./Nutrition_facts.vue?vue&type=script&lang=js&"
export * from "./Nutrition_facts.vue?vue&type=script&lang=js&"
import style0 from "./Nutrition_facts.vue?vue&type=style&index=0&id=6000fe5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6000fe5f",
  null
  
)

export default component.exports